/**
 * `modules/index.js`
 *  -  特定の機能モジュールを統合
 *
 * 使用方法:
 *  - import {initModules} from "./modules/index.js";
 */

import {initCaseArchiveFilter} from "./caseArchiveFilter.js";


export const initModules = async () => {
  console.log("📦 Initializing Modules...");
  initCaseArchiveFilter();
};